import { Component, input } from '@angular/core';

@Component({
    selector: 'app-view-assessment-cost',
    templateUrl: './view-assessment-cost.component.html',
    styleUrls: ['./view-assessment-cost.component.scss'],
    standalone: false
})


export class ViewAssessmentCostComponent {

  report = input.required<any>();

  constructor() {}
}
